import { useTranslations } from 'next-intl';
import { BaseLineCopy } from '@/app/components/icons/BaseLineCopy';
import { Button } from '@/app/components/ui/button';
import { useCopy } from '@/app/hooks';
import type { RecaptionPrompt } from '@/app/types';
import { titleCaseToCamelCase } from '@/app/utils';

export const ProTextPrompt = ({ text }: { text: string }) => {
  const prompt = JSON.parse(text) as Record<string, string>;
  const prompts = Object.entries(prompt);
  const { copy } = useCopy();
  const t = useTranslations();

  return (
    <ul className="list-disc pl-4 marker:text-system-blue02">
      {prompts.map(([key, value], index) => (
        <li key={key}>
          <span>
            {t(`create.proMode.${titleCaseToCamelCase(key) as keyof RecaptionPrompt}.title`)}
            <span className="text-system-white12">|</span>
            <span className="[word-break:break-word]">{value}</span>
          </span>
          {index === prompts.length - 1 && (
            <Button size="original" variant="text" className="ml-2 translate-y-0.5">
              <BaseLineCopy
                className="size-4 text-system-white64 hover:text-system-white"
                onClick={() => {
                  copy(
                    prompts
                      .map(
                        ([key, value]) =>
                          `${t(`create.proMode.${titleCaseToCamelCase(key) as keyof RecaptionPrompt}.title`)}: ${value}`,
                      )
                      .join('\n'),
                  );
                }}
              />
            </Button>
          )}
        </li>
      ))}
    </ul>
  );
};
